module.exports = __webpack_public_path__ + "media/images/amenities_icons/shower-f9154401808cd3402ce3fb6532be013e.svg";